import { CSSProperties } from 'react';
import {
  IconNameMedium,
  IconNameSmall
} from '@npm-registry/eapteka-ui/lib/components/Icon/icons';

export enum TCustomTooltipSides {
  left = 'left',
  right = 'right'
}

export interface TCustomTooltip {
  className?: string;
  content?: string;
  iconName?: IconNameMedium | IconNameSmall;
  side?: TCustomTooltipSides;
  style?: CSSProperties;
}
